module.exports = __webpack_public_path__ + "static/media/logo.11c3691a.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 38
// module chunks = 0